import { gql } from "@apollo/client";
import { variableFragments } from "./variableFragments";

const GLOBAL_SETS_QUERY = gql`
  query GlobalSetsQuery($siteHandle: [String]) {
    globalSets(site: $siteHandle) {
      handle
      siteId
      siteHandle
      language
      ... on customerSupport_GlobalSet {
        localeSupportInfo {
          ... on supportblock_Entry {
            id
            localeTitle
            locality
            phone
            internationalPhone
            email
            addressLine1
            addressLine2
            flag {
              url
            }
          }
        }
      }
      ... on translations_GlobalSet {
        translationKeyValuePairs {
          labelKey
          labelValue
        }
      }
    }
    globalVariables: entries(
      section: "variables"
      site: $siteHandle
      type: ["variable"]
    ) {
      id # needed for globalVariables for scoped lookups
      siteHandle # needed for apollo cache invalidation
      ...VariableEntryFields
    }
  }
  ${variableFragments}
`;

export default GLOBAL_SETS_QUERY;
